import * as FileSaver from 'file-saver';

import { metricValueFormat } from '../../utils/metricValueFormat';
import { ConstReviewStatus } from '../../utils/typeConstants';
import DisputeNeedReviewIcon from '../../assets/DisputeNeedReviewIcon.svg';
import DisputeReviewedIcon from '../../assets/DisputeReviewedIcon.svg';
import DisputedIcon from '../../assets/DisputedIcon.svg';

// import { metricValueFormat } from '../scoreCardDashboardTable/ScoreCardDashboardViewTable';

export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};

export const expAgent = (agents: any, metricColHeader: any) => {
    const expAge = [{}];
    for (let i = 0; i < agents.length; i++) {
        const agent = agents[i];
        let arr = [];
        let count = 1;
        arr = metricColHeader.map((x: any) => {
            let y = x;
            y = y.replaceAll(' - ', '_');
            const agentMetrics = agent?.agentMetrics;
            if (agentMetrics !== undefined && agentMetrics !== null && agentMetrics.length > 0) {
                let metricValue = agentMetrics[0].metricsDetails[x]?.metric_value;
                const metricTypeName = agentMetrics[0].metricsDetails[x]?.metric_type_name;
                metricValue = metricValueFormat(metricValue, metricTypeName);
                return { [y]: metricValue };
            }
            count += 1;
            return { [y]: agent['col' + count] };
        });

        expAge.push({
            Date: `${agent.metric_date}`,
        });
        arr.map((x: any) => {
            return Object.assign(expAge[i + 1], x);
        });
    }
    return expAge;
};

export const getClosedDisputesIds = (rowData: any): string[] => {
    return rowData?.resolve_disputes?.split(',');
};

export const hasResolvedDisputes = (rowData: any): boolean => {
    return (
        rowData?.resolve_disputes !== '' &&
        rowData?.resolve_disputes !== null &&
        rowData?.resolve_disputes !== undefined
    );
};
export const statusIcon = (rowData: any) => {
    let icon = null;
    switch (rowData.review_status_id) {
        case ConstReviewStatus.NEEDS_REVIEW:
            icon = DisputeNeedReviewIcon;
            break;
        case ConstReviewStatus.REVIEWED:
            icon = DisputeReviewedIcon;
            break;
        default:
            icon = DisputedIcon;
            break;
    }
    return icon;
}
export const exportExcel = (agents: any,metricColHeader: any) => {
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(expAgent(agents, metricColHeader));
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAsExcelFile(excelBuffer, 'agents');
    });
};
export const isRowSelectable = (event: any) => {
    return event.data.review_status_id !== ConstReviewStatus.REVIEWED;
};